import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import styles from "./Table.module.scss";

export default function CustomTable({
  tableHead,
  tableData,
  tableHeaderColor = "gray",
  hover = false,
  colorsColls = [],
  coloredColls = [],
  customCellClasses = [],
  customClassesForCells = [],
  striped = false,
  tableShopping = false,
  customHeadCellClasses = [],
  customHeadClassesForCells = []
}) {
  return (
    <div className={styles.tableResponsive}>
      <Table className={styles.table}>
        {tableHead !== undefined ? (
          <TableHead className={styles[tableHeaderColor]}>
            <TableRow className={styles.tableRow}>
              {tableHead.map((prop, key) => {
                const tableCellClasses = cx(
                  styles.tableHeadCell,
                  styles.tableCell,
                  {
                    [customHeadCellClasses[
                      customHeadClassesForCells.indexOf(key)
                    ]]: customHeadClassesForCells.indexOf(key) !== -1,
                    [styles.tableShoppingHead]: tableShopping
                  }
                );
                return (
                  <TableCell className={tableCellClasses} key={key}>
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.map((prop, key) => {
            var rowColor = "";
            var rowColored = false;
            if (prop.color !== undefined) {
              rowColor = prop.color;
              rowColored = true;
              prop = prop.data;
            }
            const tableRowClasses = cx(styles.tableRow, {
              [styles.tableRowHover]: hover,
              [styles[`${rowColor}Row`]]: rowColored,
              [styles.tableStripedRow]: striped && key % 2 === 0
            });
            if (prop.total) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={styles.tableCell}
                    colSpan={prop.colspan}
                  />
                  <TableCell
                    className={cx(styles.tableCell, styles.tableCellTotal)}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    className={cx(styles.tableCell, styles.tableCellAmount)}
                  >
                    {prop.amount}
                  </TableCell>
                  {tableHead.length - (prop.colspan - 0 + 2) > 0 ? (
                    <TableCell
                      className={styles.tableCell}
                      colSpan={tableHead.length - (prop.colspan - 0 + 2)}
                    />
                  ) : null}
                </TableRow>
              );
            }
            if (prop.purchase) {
              return (
                <TableRow key={key} hover={hover} className={tableRowClasses}>
                  <TableCell
                    className={styles.tableCell}
                    colSpan={prop.colspan}
                  />
                  <TableCell
                    className={cx(styles.tableCell, styles.tableCellTotal)}
                  >
                    Total
                  </TableCell>
                  <TableCell
                    className={cx(styles.tableCell, styles.tableCellAmount)}
                  >
                    {prop.amount}
                  </TableCell>
                  <TableCell
                    className={cx(styles.tableCell, styles.right)}
                    colSpan={prop.col.colspan}
                  >
                    {prop.col.text}
                  </TableCell>
                </TableRow>
              );
            }
            return (
              <TableRow
                key={key}
                hover={hover}
                className={tableRowClasses}
              >
                {prop.map((prop, key) => {
                  const tableCellClasses = cx(
                    styles.tableCell,
                    {
                      [styles[colorsColls[coloredColls.indexOf(key)]]]:
                        coloredColls.indexOf(key) !== -1,
                      [customCellClasses[customClassesForCells.indexOf(key)]]:
                        customClassesForCells.indexOf(key) !== -1
                    }
                  );
                  return (
                    <TableCell className={tableCellClasses} key={key}>
                      {prop}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.array.isRequired,
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  colorsColls: PropTypes.array,
  customCellClasses: PropTypes.arrayOf(PropTypes.string),
  customClassesForCells: PropTypes.arrayOf(PropTypes.number),
  customHeadCellClasses: PropTypes.arrayOf(PropTypes.string),
  customHeadClassesForCells: PropTypes.arrayOf(PropTypes.number),
  striped: PropTypes.bool,
  tableShopping: PropTypes.bool
};